import React from 'react'
import { useTranslation } from 'react-i18next'
import Contatos from '../components/Contatos'
import Created from '../components/Created'
import Header from '../components/Header'




export default function ContatoPage () {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col bg-gray-800">
        < Header
          langSwitcher
          appsBackEnd={t('nav.projetos')}
          tecnologias={t('nav.tecnologias')}
          homePage={t('nav.homePage')}
        />
        <div className="flex flex-1 flex-col">
          <Contatos/>
        </div>
        <Created/>
    </div>
  )
}
